var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-content-container mx-auto h-full",class:{'app-content-container-boxed': _vm.appContentWidth === 'boxed'}},[_vm._t("default"),_c('Message'),_c('loader')],2)}
var staticRenderFns = []

export { render, staticRenderFns }